import { styled } from '@mui/material/styles';

export const Container = styled('div')`
  text-align: center;
  padding: 0;
`;
